<template>
    <div class="fifth_pc_page" id="fifth_pc_page">
        <!-- <div class="pc_loading" id="pc_page"> -->
        <!-- 活动标题 -->
        <div class="wechat-title" v-wechat-title="'最强蜗牛'"></div>
        <a class="btn scale-div" :href="PcTrialConfig.translations.official">
            <img class="swiper-lazy" :src="PcTrialConfig.translations.btn" alt="详情">
        </a>
        <div class="slogan scale-div">
            <img class="swiper-lazy" :src="PcTrialConfig.translations.slogan" alt="详情">
        </div>
        <div class="logo scale-div">
            <img class="swiper-lazy" :src="PcTrialConfig.translations.logo" alt="详情">
        </div>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
            :duration="{ enter: 1000 }">
            <div :class="boxShow ? 'box box-in scale-div' : 'box scale-div'" v-if="PcTrialConfig.translations.code_show">
                <div class="in" @click="changeBox" v-if="boxShow"></div>
                <div class="out" @click="changeBox" v-else></div>
                <img class="swiper-lazy" :src="PcTrialConfig.translations.code" alt="详情">
            </div>
        </transition>
        <div class="bottom">
            <div class="fifth-snail-tvShow-captions-text-pc" v-html="PcTrialConfig.translations.captions"></div>
        </div>

    </div>
</template>
<script>
import { getRandomString } from '@/utils/utils';
import { PcTrialConfig } from '../PcTrialConfig';
export default {
    name: 'fifth-pc',
    data() {
        return {
            PcTrialConfig: null,
            boxShow: false,
            URLS: {
                'ja-jp': 'https://h5-sg.qcplay.com/',
                'zh-cn': 'https://h5.qingcigame.com/',
                'zh-tw': 'https://h5.snell.com.tw/'
            },
        }
    },
    created() {
        var userAgent = navigator.userAgent.toLowerCase();
        var isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;
        if (isPC) {
            console.log('当前设备是 PC');
        } else {
            this.$router.push(`enter${getRandomString()}`);
            console.log('当前设备不是 PC');
        }

        this.language = this.getCurrentUrlKeyByOrigin();
        // this.language = 'zh-tw';
        this.PcTrialConfig = new PcTrialConfig(this.language);
        const reload = () => {
            const { protocol, host } = window.location;
            const link = `${protocol}//${host}/snail/fifth/pc${getRandomString()}`;
            setTimeout(() => {
                window.location.href = `${link}?referer=game`;
            }, 200);
        };

    },
    mounted() {
    },
    methods: {

        getCurrentUrlKeyByOrigin() {
            const currentOrigin = window.location.origin;
            const entries = Object.entries(this.URLS);
            for (let [key, fullUrl] of entries) {
                const urlOrigin = new URL(fullUrl).origin; // 提取 URLS 中每个值的 origin
                if (currentOrigin === urlOrigin) {
                    return key;
                }
            }
            return 'zh-cn'; // 未匹配到时返回 zh
        },
        changeBox() {
            this.boxShow = !this.boxShow
        }
    }
}
</script>
<style lang="less">
@import url("./pc.less");
</style>
<style lang="less">
.fifth-snail-tvShow-captions-text-pc {
    font-family: SourceHanSansCNBlod;
    font-weight: bold;
    font-size: 3vw;
    color: #FFFFFF;
    text-align: left;
    font-style: normal;
    text-transform: none;
    animation: marquee 30s linear infinite;
    position: absolute;
    bottom: 0.5vw;
    padding-left: 30%;
    white-space: nowrap;

    /* 初始位置在右侧 */
    span {
        position: relative;
        display: inline-block;
    }

    span::after {
        content: '';
        position: absolute;
        left: 0;
        top: 45%;
        /* 调整线条垂直位置 */
        width: 100%;
        height: 5px;
        /* 线条粗细 */
        background: #f00;
        /* 线条颜色 */
        transform: rotate(-19deg);
        /* 调整倾斜角度 */
        opacity: 0.8;
        /* 线条透明度 */
    }

    @keyframes marquee {
        0% {
            transform: translateX(30%);
        }

        100% {
            transform: translateX(-100%);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/snail/5thReport/pc/index.vue